import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AppConfig } from '@app/core/app.config';
import { EntityTypeEnum } from '@app/core/enums/entity-type.enum';
import {
  CreateDatagridVisualisationNameReset
} from '@app/shared/store/reducers/create-datagrid-visualisation-name.actions';
import { ExtraValidators } from '@app/shared/validators/extra-validators.module';
import { Store } from '@ngrx/store';
import ApiService from '@services/api.service';
import { AccessManager } from '@services/managers/access.manager';
import { AppManager } from '@services/managers/app.manager';

@Component({
  templateUrl: './create-datagrid-visualisation-modal.component.html',
  standalone: false
})
export class CreateDatagridVisualisationModalComponent implements OnInit, OnDestroy {
  private apiService = inject(ApiService);
  private fb = inject(FormBuilder);
  private store = inject<Store<any>>(Store);
  private appManager = inject(AppManager);
  protected appConfig = inject(AppConfig);
  private accessManager = inject(AccessManager);
  private data = inject(MAT_DIALOG_DATA);

  public visualisationForm: FormGroup<{ name: FormControl<string> }>;

  public ngOnInit(): void {
    this.visualisationForm = this.fb.group({
      name: this.fb.control('', Validators.compose([
        Validators.required,
        Validators.maxLength(this.appConfig.NAME_MAX_LENGTH)
      ]))
    });
    this.visualisationForm.controls.name.setAsyncValidators(
      ExtraValidators.isValueTaken(this.apiService, EntityTypeEnum.DATAGRID_VISUALISATION, 'name', '', {
        datagrid: this.data.datagrid,
        organizationId: this.appManager.currentOrganization.id,
        user: this.accessManager.currentUser.id
      }, {
        store: this.store,
        fieldName: 'createDatagridVisualisationName'
      })
    );
  }

  public ngOnDestroy(): void {
    this.store.dispatch(new CreateDatagridVisualisationNameReset({currentValue: '', originalValue: ''}));
  }

  public getGeneratedObject(): any {
    return {
      visualisationName: this.visualisationForm.controls.name.value
    };
  }

}
